import './assets/js/adapt.js'
import Vue from 'vue'


import App from './App'
import router from './router'
import Common from './common/js/common.js'
import Util from './common/js/util.js'
import store from './vuex/index.js'
import qs from 'qs'

import './styles/index.less'

import htmlToPdf from '@/components/utils/htmlToPdf'

Vue.use(htmlToPdf)

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI)

import VueAwesomeSwiper from 'vue-awesome-swiper'




Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.use(DatetimePlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)
Vue.use(LoadingPlugin)




var _hmt = _hmt || [];

window.localStorage.setItem("appType", "");
window.localStorage.setItem("auth", "");
window.localStorage.setItem("deviceid", 1);
window.localStorage.setItem("channel", "default");
window.localStorage.setItem("appid", 70);
window.localStorage.setItem("appVersion", "v1.0.0");
window.localStorage.setItem("apiVersion", "v1.0.0");
window.localStorage.setItem("appKey", "b07f2c370e974f969a39708bc1277482");

router.beforeEach((to, from, next) => {
if (_hmt) {
if (to.path) {
_hmt.push(['_trackPageview', '/#' + to.fullPath]);
}
let id = ''
if (to.path === 'Download') {
id = 'ba61eb220aae6aedcaada1eee60b0736'
} else {
id = 'b121b2e17fac857b31580d400ef67e52'
}
(function () {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?" + id;
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
})();
}
next();
});














import IosSelect from 'iosselect'
import '../node_modules/iosselect/src/iosSelect.css'

import './assets/js/calendar2.min.js'
import './assets/css/calendar2.css'

Vue.config.productionTip = false

const whiteList = ['/', '/authorize', '/pay', '/pay-result']










































new Vue({
el: '#app',
router,
store,
components: {App},
methods: {
IosSelect
},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js